<template>
  <div class="video-shell" @click="toggleVideo">
    <div v-if="!playing" class="video-placeholder">
      <div class="video-play">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#0C0600" style="margin-left: 4px">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
      <div class="video-caption">{{ caption }}</div>
    </div>
    <video
      v-if="src"
      ref="video"
      :poster="poster"
      class="video-el"
      controls
      preload="none"
      :style="{ display: playing ? 'block' : 'none' }"
    >
      <source :src="src" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  name: 'HeroVideo',
  props: {
    src: {
      type: String,
      default: '',
    },
    poster: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      playing: false,
    }
  },
  methods: {
    toggleVideo() {
      if (!this.src) {
        return
      }
      this.playing = true
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.play()
        }
      })
    },
  },
}
</script>

<style scoped>
.video-shell {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #0a0600;
  border: 1px solid var(--border);
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.video-placeholder {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #0f0800, #2d1800, #0f0800);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 2;
}

.video-play {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--gold), var(--amber));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 28px rgba(245, 200, 66, 0.45);
}

.video-caption {
  font-size: 12px;
  color: rgba(255, 245, 220, 0.4);
}

.video-el {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
